import {Component, ElementRef, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {Config} from '../config';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import {FormControl, FormGroup} from '@angular/forms';

import MapImageLayer = require('esri/layers/MapImageLayer');
import Point = require('esri/geometry/Point');
import SimpleFillSymbol = require('esri/symbols/SimpleFillSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import SimpleMarkerSymbol = require('esri/symbols/SimpleMarkerSymbol');
import PictureMarkerSymbol = require('esri/symbols/PictureMarkerSymbol');
import Polygon = require('esri/geometry/Polygon');
import Polyline = require('esri/geometry/Polyline');
import GeometryEngine = require('esri/geometry/geometryEngine');
import on = require('dojo/on');
import ScreenPoint = require('esri/geometry/ScreenPoint');
import Color = require('esri/Color');
import Graphic = require('esri/Graphic');
import Legend = require('esri/widgets/Legend');
import IdentifyParameters = require('esri/tasks/support/IdentifyParameters');
import IdentifyTask = require('esri/tasks/IdentifyTask');
import PopupTemplate = require('esri/PopupTemplate');
import Collection = require('esri/core/Collection');
import SpatialReference = require('esri/geometry/SpatialReference');

import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'navTools-component',
    template: require('../tools/navTools.component.html'),
    styles: [require('../tools/navTools.component.css')]
})
export class NavToolsComponent {
    appSettings: Object = null;
    zoomInInstructions:string = 'Press "Shift" button and drag area you want to zoom to or double click on the map.';
    zoomOutInstruction:string = 'Scroll backward or press "Shift" and double click.';
    drawHandler: any;
    freeHandDrawMapViewHandler:any;
    drawPolygonHandler: any;
    polygonDrawMoveHandler: any;
    polygonDrawDoubleClickHandler: any;
    drawPolygonScreenClickHandler: any;

    identifyFeatureItems:Array<any>;
    identifyPoint:Point;
    identifyIterator:number = 0;

    mapClickSubscription:Subscription;
    mapDragSubscription:Subscription;
    mapPointerDownSubscription:Subscription;
    mapPointerUpSubscription:Subscription;
    mapPointerMoveSubscription:Subscription;
    mapDoubleClickSubscription:Subscription;

    obliquePhotoSyncSubscription:Subscription;

    @ViewChild('addressSearchIcon') addressSearchIcon: ElementRef;
    @ViewChild('obliqueIcon') obliqueIcon: ElementRef;
    extendToolbar:boolean = false;

    private freeHandInstructions:string = "Click and hold on the map to start. Continue to hold the click and move mouse to draw a freehand polygon. Release the click to complete the freehand polygon."
    private showFreeHandInstructions:boolean = true;

    private drawPolygonInstructions:string = "Click and release on the map to start drawing. Continue to click and release on the map to place additional vertices. Double-click on the map to complete the polygon.";
    private showDrawPolygonInstructions:boolean = true;

    private identifyInstructions:string = "Click on the map to find more information about the clicked feature.";
    private showIdentifyInstructions:boolean = true;

    private obliqueImageyInstructions:string = "Click on the map to place graphic on the map and see oblique image in the selected point. As you move the graphic on the map, it will update the oblique image view with the new location. Vice versa, the location of the graphic will change if you change the oblique view."
    private showObliqueImageyInstructions:boolean = true;

    private toolsInstructions:string = "Select a tool to see instructions on how to use it.";
    private showToolsInstructions:boolean = true;

    identifyToolListActive:boolean = false;
    obliqueToolListActive:boolean = false;
    freeHandToolListActive:boolean = false; 
    drawPolygonToolListActive:boolean = false;

    constructor(private elRef:ElementRef, private _mapService:MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService){

    }

    ngOnInit(){
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
            //this.setUpWidget();
        }else{
            //this.setUpWidget();
        }

        this._eventsService.navItem$.subscribe(suggestion => {      
            if(this.addressSearchIcon.nativeElement.checked == true){
                this.addressSearchIcon.nativeElement.click();
            }
        });

        this._eventsService.disableObliqueImage$.subscribe(() => {
            this.obliqueIcon.nativeElement.click();
        });
    }

    expandToolbarFunction(){
        this.extendToolbar = !this.extendToolbar;
        this._eventsService.expandMenuToolbar(this.extendToolbar);
    }


    fullExtent(){
        this._mapService.view.zoom = 4;
        //map is loaded, then do some stuff
        var pt:Point = new Point({
            x: this.appSettings["Map"]["Center"]["x"],
            y: this.appSettings["Map"]["Center"]["y"],
            spatialReference: this._mapService.view.spatialReference
        });
        this._mapService.view.center = pt;
    }

    selectToolFromList(toolValue:string){
        var mapNavToolEls:NodeListOf<any> = document.getElementsByName("mapToolActive");
        for(var k = 0; k < mapNavToolEls.length; k++){
            if(mapNavToolEls[k].value == toolValue){
                mapNavToolEls[k].click();
                return;
            }
        }
    }

    selectMapNavTool(event){
        if(event.checked == true){
            var mapNavToolEls:NodeListOf<any> = document.getElementsByName("mapToolActive");
            for(var k = 0; k < mapNavToolEls.length; k++){
                if(mapNavToolEls[k].checked == true && mapNavToolEls[k].value != event.value){
                    mapNavToolEls[k].click();
                }
            }
            //this._eventsService.mapNavigationTool({"name": event.currentTarget.value, "value":true});
            this.hideSnackBar();
            switch(event.value){
                // case "Zoom In":
                //     setTimeout(() =>
                //     {
                //         this.showSnackBar(this.zoomInInstructions, 60000);
                //     }, 800);
                //     break;
                // case "Zoom Out":
                //     setTimeout(() =>
                //     {
                //         this.showSnackBar(this.zoomOutInstruction, 60000);
                //     }, 800);
                //     break;
                case "Free Hand Draw":
                    this.NEWFreeHandPolygonToolActivate();
                    break;
                case "Polygon Draw Tool":
                    this.NEWdrawPolygonToolActivate();
                    break;
                case "Identify":
                    this.identifyToolActivate();
                    break;
                case "Oblique Imagery":
                    this.obliqueImageryActivate();
                    break;
            }
        }else{
            //this._eventsService.mapNavigationTool({"name": event.currentTarget.value, "value":false});
            this.hideSnackBar();
            switch(event.value){
                // case "Zoom In":
                //     setTimeout(() =>
                //     {
                //         this.showSnackBar({message:this.zoomInInstructions, 60000);
                //     }, 800);
                //     break;
                // case "Zoom Out":
                //     setTimeout(() =>
                //     {
                //         this.showSnackBar(this.zoomOutInstruction, 60000);
                //     }, 800);
                //     break;
                case "Free Hand Draw":
                    this.NEWFreeHandPolygonToolDeactivate();
                    break;
                case "Polygon Draw Tool":
                    this.NEWdrawPolygonToolDeactivate();
                    break;
                case "Identify":
                    this.identifyToolDeactivate();
                    break;
                case "Oblique Imagery":
                    this.obliqueImageryDeactivate();
                    break;
            }
        }
    }


    private identifyToolActivate(){
        this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to identify"});
        this.identifyToolListActive = true;
        if(this.showIdentifyInstructions == true){
            var dataSnack = {
                message: this.identifyInstructions, 
                timeout:15000,
                actionHandler: e => {
                    this.hideSnackBar();
                    this.showIdentifyInstructions = false;
                },
                actionText: "Hide"
            };
            this.showSnackBar(dataSnack);
        }
        
        this.mapClickSubscription = this._eventsService.mapClicked$.subscribe(evt => {
            this._mapService.view.popup.clear();
            this._mapService.view.popup.actions.removeAll();
            setTimeout(() => {
                if(this._mapService.view.popup.content == "" || this._mapService.view.popup.content == null){
                    this._mapService.view.popup.open({
                        content:"Please wait...",
                        location:evt.mapPoint
                    });
                }
            }, 200);
            
            this.identifyPoint = evt.mapPoint;
            this._eventsService.identifyLocationChanged(this.identifyPoint);
            this.identifyFeatureItems = [];
            this.identifyIterator = 0;
            this.doIdentifyTask();
        });

        this.mapPointerDownSubscription = this._eventsService.mapPointerDown$.subscribe(evt => {
            this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        });
    }

    doIdentifyTask(){
        var idMSUrl:string = this._mapService.currentDynamicLayers[this.identifyIterator].url;
        var layersToIdentify:Array<number> = [];
        var layers:Array<any> = this._mapService.currentDynamicLayers[this.identifyIterator].sublayers["items"];
        var definitionExpressions:Object = {};
        for(var layer of layers){
            if(layer["visible"] == true){
                layersToIdentify.push(layer["id"]);
                definitionExpressions[layer["id"]] = (layer["definitionExpression"]) as Object;
            }
        }
        this._esriTasksService.identifyFeatures(idMSUrl, this.identifyPoint, this._mapService.view.extent, 1, layersToIdentify, "visible", true, definitionExpressions)
            .then(item => 
                {
                    this._mapService.view.popup.open({
                        content:"Please wait...",
                        location:this.identifyPoint
                    });
                    this.processIdentifyResults(item.results, this.identifyPoint);
                }, error => {
                console.log(error);
            });
    }

    processIdentifyResults(results:Array<any>, point:Point){
        for (let result of results){
            let feature:Graphic = result.feature;
            let layerName = result.layerName;
            let popupTemplate = new PopupTemplate();

            popupTemplate.title = layerName;
            
            var attributes:any = feature.attributes;
            try{
                switch(layerName){
                    case "Land Use Plan Base Typology":
                        popupTemplate.content = "<b>Recommended Land Use: </b>" + attributes["USEDESC"] + "<br/>" + "<b>Adopting Resolution: </b>" + attributes["RESOLUTION"];
                        break;
                    case "Land Use Plan Overlays":
                        popupTemplate.content =  "<b>Overlay Type: </b>" + attributes["TypeName"] + "<br/>" + "<b>Overlay ID: </b>" + attributes["ID"] + "<br/>" + "<b>Adopting Resolution: </b>" + attributes["Resolution"];
                        break;
                    case "Specific Area Plan":
                        this._esriTasksService.getServiceValues(this.appSettings["ResolutionFiles"]["serviceURL"] + "/" + attributes["Resolution"]).then(resDocInfo => {
                            popupTemplate.content = "<b>Specific Area Plan Name: </b>" + resDocInfo["PlanName"] + "<br/>" + "<b>Adopting Resolution: </b>" + resDocInfo["Resolution"];
                        }).catch(error => {
                            popupTemplate.content =  "<b>Adopting Resolution: </b>" + attributes["Resolution"];
                        });
                        break;
                    case "DMD Certified Plans":
                        popupTemplate.content = "<b>Certified Plan Name: </b>" + attributes["NAME"] + "<br/>" + "<b>Certification Period: </b>" + attributes["START_DATE"] + " to " + attributes["EXPIRE_DATE"];
                        break;
                    case "Redevelopment/Economic Development Areas":
                        var areaDescription:string = null;
                        if(attributes["EDAorRDA"] == "RDA"){
                            areaDescription = "Redevelopment Area";
                        }else if(attributes["EDAorRDA"] == "EDA"){
                            areaDescription = "Economic Development Area";
                        }
                        popupTemplate.content = "<b>Area Name: </b>" + attributes["NAME"] + ((areaDescription != null) ? ("<br/>" + "<b>Area Type: </b>" + areaDescription) : "");
                        break;
                    case "TIF Districts":
                        popupTemplate.content = "<b>TIF Allocation Area Name: </b>" + attributes["TIF_NAME"] + "<br/>" + "<b>TIF Type: </b>" + attributes["TIF_TYPE"];
                        break;
                    case "CRED Districts":
                        popupTemplate.content = "<b>CRED Name: </b>" + "Lafayette Square CRED";
                        break;
                    case "Certified Technology Parks":
                        popupTemplate.content = "<b>CTP Name: </b>" + attributes["NAME"];
                        break;
                    case "Promise Zone":
                        popupTemplate.content = "<b>Name: </b>IndyEast Promise Zone";
                        break;
                    case "Opportunity Zone":
                        popupTemplate.content = "<b>Opportunity Zone: </b>Yes";
                        break;
                    case "Neighborhood Revitalization Strategy Area":
                        popupTemplate.content = "<b>Name: </b>" + attributes["NAME"];
                        break;
                    case "Economic Improvement Districts":
                        popupTemplate.content = "<b>Name: </b>" + attributes["NAME"];
                        break;
                    case "Market Value Analysis":
                        popupTemplate.content = "<b>Market Value: </b>" + attributes["MVA_FINAL"];
                        break;
                    case "Neighborhood Investment Analysis":
                        popupTemplate.content = "<b>Neighborhood Type: </b>" + attributes["NIA_FINAL"];
                        break;
                    case "Thoroughfare Plan":
                        var status:string = null;
                        if(attributes["OPER_STATUS"] == "BUILT"){
                            status = "Built"
                        }else if(attributes["OPER_STATUS"] == "BUILT_EP" || attributes["OPER_STATUS"] == "BUILT_EP2"){
                            status = "Proposed Expansion to " + attributes["LANES"] + "Travel Lanes";
                        }else if(attributes["OPER_STATUS"] == "PLANNED TFARE"){
                            status = "Planned New Terrain Street with " + attributes["LANES"] + "Travel Lanes";
                        }else if(attributes["OPER_STATUS"] == "BUILT_MMEP"){
                            status = "Planned Expansion for MultiModal Trail or Greenway";
                        }else if(attributes["OPER_STATUS"] == "PLANNED MM"){
                            status = "Planned MultiModal Trail or Greenway";
                        }
                        var rowWidth:String = null;
                        if(attributes["PROP_ROW"] == 0){
                            rowWidth = "Existing";
                        }else{
                            rowWidth = attributes["PROP_ROW"] + "'";
                        }
                        popupTemplate.content = "<b>Street Name: </b>" + attributes["FULL_STNAME"] + 
                                    "<br/>" + "<b>Thoroughfare Class: </b>" + attributes["T_FARE"] + 
                                    ((status != null) ? ("<br/>" + "<b>Status: </b>" + status) : "") +
                                    "<br/>" + "<b>Proposed Right-of-Way Width: </b>" + rowWidth;
                        break;
                    case "Bikeways and Greenways":
                        popupTemplate.content = "<b>Name: </b>" + attributes["STREET_NAME"] + 
                        "<br/>" + "<b>Type: </b>" + attributes["TYPE"] + 
                        "<br/>" + "<b>Status: </b>" + attributes["STATUS"]+
                        "<br/>" + "<b>Adopting Resolution: </b>" + attributes["RESOLUTION"];
                        break;
                    case "Pedestrian Plan Priority Areas":
                        popupTemplate.content = "<b>Priority Tier: </b>" + attributes["TIER"];
                        break;
                }
            }catch(exc){
                console.log(exc);
                var content:string = "";
                for(let attribute in attributes){
                    if(content == ""){
                        content = attribute + ": " + attributes[attribute];
                    }else{
                        content = content + "<br/>" + attribute + ": " + attributes[attribute];
                    }
                }
                popupTemplate.content = content;
            }

            
            feature.popupTemplate = popupTemplate;

            feature.popupTemplate.actions = new Collection();
            // Defines an action that zooms out from the selected feature
            let zoomToAction = {
                // This text is displayed as a tool tip
                title: "Zoom to",
                id: "zoom-to-addon",
                // An icon font provided by the API
                className: "esri-icon-zoom-in-magnifying-glass"
            };
            // Adds the action to the view's default popup.
            feature.popupTemplate.actions.push(zoomToAction);

            //Add action to open new page with .pdf document
            if((this.appSettings["ResolutionFiles"]["resolutionLayerField"] as Object).hasOwnProperty(result.layerName)){
                if(feature.attributes.hasOwnProperty(this.appSettings["ResolutionFiles"]["resolutionLayerField"][result.layerName])){
                    var openPDFDocAction = {
                        title:"See document",
                        id: "see-document",
                        className: "esri-icon-link-external",
                        extra: {
                            resolutionValue:feature.attributes[this.appSettings["ResolutionFiles"]["resolutionLayerField"][result.layerName]]
                        }
                    };
                    feature.popupTemplate.actions.push(openPDFDocAction);
                }
            }
    
            this.identifyFeatureItems.push(feature);
        }
        this.identifyIterator++;
        if(this.identifyIterator < this._mapService.currentDynamicLayers.length){
            this.doIdentifyTask();
        }else{
            var layersToIdentify:Array<number> = this.appSettings["IdentifyTool"]["Parcels"]["layers"];
            this._esriTasksService.identifyFeatures(this.appSettings["IdentifyTool"]["Parcels"]["URL"], this.identifyPoint, this._mapService.view.extent, 1, layersToIdentify, this.appSettings["IdentifyTool"]["Parcels"]["searchOptions"], true, {})
            .then(item => 
                {
                    if(item.results && item.results[0]){
                        var resultFeature:any = item.results[0]["feature"];
                        var parcelNumber:string = resultFeature["attributes"]["PARCEL_C"];
                        var parcelAddress:string = resultFeature["attributes"]["STNUMBER"] + " " + ((resultFeature["attributes"]["PRE_DIR"] == "Null") ? "" : (resultFeature["attributes"]["PRE_DIR"] + " ")) + resultFeature["attributes"]["FULL_STNAME"] + " " + resultFeature["attributes"]["CITY"] + ", " + resultFeature["attributes"]["STATE"] + " " + resultFeature["attributes"]["ZIPCODE"];
                        var parcelGraphic:Graphic = new Graphic();
                        parcelGraphic.attributes = {"Parcel Number": parcelNumber, "Parcel Address": parcelAddress};
                        parcelGraphic.geometry = resultFeature.geometry;
                        this.createParcelPopup(parcelGraphic);
                    }
                    this.showResultsPopup(point);
                }, error => {
                console.log(error);
                this.showResultsPopup(point);
            });
        }
    }

    private createParcelPopup(parcelGraphic:Graphic){
        var parcelPopupTemplate = new PopupTemplate();
        parcelPopupTemplate.title = "Parcels";
        var parcelPopupContent:string = "";
        for(let attribute in parcelGraphic.attributes){
            if(parcelPopupContent == ""){
                parcelPopupContent = attribute + ": " + parcelGraphic.attributes[attribute];
            }else{
                parcelPopupContent = parcelPopupContent + "<br/>" + attribute + ": " + parcelGraphic.attributes[attribute];
            }
        }
        var parcelReportIconPath:string = "./images/parcel-report-icon.png";
        let parcReportAction = {
            title:"Generate Parcel Report",
            id: "parcel-report",
            //className: "esri-icon-documentation",
            image: parcelReportIconPath
        };
        let prcAction:any = {
            title:"Show property report card",
            id: "prc-card",
            className: "esri-icon-launch-link-external"
        };
        let zoomToAction = {
            title: "Zoom to",
            id: "zoom-to-addon",
            className: "esri-icon-zoom-in-magnifying-glass"
        };
        parcelPopupTemplate.actions = new Collection();
        parcelPopupTemplate.actions.addMany([zoomToAction, prcAction, parcReportAction]);
        parcelPopupTemplate.content = parcelPopupContent;
        parcelGraphic.popupTemplate = parcelPopupTemplate;
        this.identifyFeatureItems.push(parcelGraphic);
    }

    private showResultsPopup(point:Point){
        if(this.identifyFeatureItems.length > 0){
            this._mapService.view.popup.open({
                features:this.identifyFeatureItems,
                location:point
            });
        }else{
            this._mapService.view.popup.open({
                content:"No features found at the specified location.",
                location:point
            });
        }
    }

    private identifyToolDeactivate(){
        this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        this.mapClickSubscription.unsubscribe();
        this.mapPointerDownSubscription.unsubscribe();
        this.identifyToolListActive = false;
    }

    private obliqueImageryActivate(){
        var pointSym:PictureMarkerSymbol = new PictureMarkerSymbol();
        pointSym.url = "./images/i_pin3.png";
        pointSym.width = 24;
        pointSym.height = 24;
        pointSym.xoffset = 6;
        pointSym.yoffset = 9;

        this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to start"});
        this.obliqueToolListActive = true;
        if(this.showObliqueImageyInstructions == true){
            var dataSnack = {
                message: this.obliqueImageyInstructions, 
                timeout:20000,
                actionHandler: e => {
                    this.hideSnackBar();
                    this.showObliqueImageyInstructions = false;
                },
                actionText: "Hide"
            };
            this.showSnackBar(dataSnack);
        }
        this.mapPointerDownSubscription = this._eventsService.mapPointerDown$.subscribe(mdevt => {
            this._eventsService.showMapTooltip({"show":false, "tooltip":""});
            this._eventsService.showObliqueImage(true);
            if(this._mapService.obliquePointGraphicLayer.graphics.length == 0){
                mdevt.stopPropagation();
                var point:Point = this._mapService.view.toMap(new ScreenPoint({
                    x:mdevt.x,
                    y:mdevt.y
                }));
                var newTestCenterGraphic:Graphic = new Graphic({
                    geometry: point,
                    symbol: pointSym
                });
                this._mapService.obliquePointGraphicLayer.graphics.add(newTestCenterGraphic);
                this.obliqueImageryPointerUp();
            }else{
                var oblGraphic:Graphic = this._mapService.obliquePointGraphicLayer.graphics.getItemAt(0);
                var oblScreenPoint:ScreenPoint = this._mapService.view.toScreen(oblGraphic.geometry as Point);
                if(Math.round(oblScreenPoint.x) < (mdevt.x + 10) && Math.round(oblScreenPoint.x) > (mdevt.x - 10) && Math.round(oblScreenPoint.y) < (mdevt.y + 10) && Math.round(oblScreenPoint.y) > (mdevt.y - 10)){
                    this.obliqueImageryPointerUp();
                    this._eventsService.showMapTooltip({"show":true, "tooltip":"Drop pin to see oblique image"});
                    this.mapDragSubscription = this._eventsService.mapDrag$.subscribe(evt => {
                        evt.stopPropagation();
                        var point:Point = this._mapService.view.toMap(new ScreenPoint({
                            x:evt.x,
                            y:evt.y
                        }));
                        var newTestCenterGraphic:Graphic = new Graphic({
                            geometry: point,
                            symbol: pointSym
                        });
                        this._mapService.obliquePointGraphicLayer.graphics.removeAll();
                        this._mapService.obliquePointGraphicLayer.graphics.add(newTestCenterGraphic);
                    });
                }
            }
        });
        this.obliquePhotoSyncSubscription = this._eventsService.ipaSyncLocation$.subscribe(view => {
            let point:Point = new Point({
                x:view.x,
                y:view.y,
                spatialReference: new SpatialReference({wkid:4326})
            });
            this._esriTasksService.projectGeometries(this.appSettings["GeometryService"]["url"], [point], this._mapService.view.spatialReference).then(result => {
                if(result[0]){
                    let newPoint:Point = result[0]
                    let newGraphic:Graphic = new Graphic({
                        geometry: newPoint,
                        symbol: pointSym
                    });
                    this._mapService.obliquePointGraphicLayer.graphics.removeAll();
                    this._mapService.obliquePointGraphicLayer.graphics.add(newGraphic);
                }
            })
        });
    }

    private obliqueImageryPointerUp(){
        this.mapPointerUpSubscription = this._eventsService.mapPointerUp$.subscribe(muevt => {
            this._eventsService.showMapTooltip({"show":false, "tooltip":""});
            if(this.mapDragSubscription){
                this.mapDragSubscription.unsubscribe();
            }
            var point:Point = this._mapService.view.toMap(new ScreenPoint({
                x:muevt.x,
                y:muevt.y
            }));
            this._esriTasksService.projectGeometries(this.appSettings["GeometryService"]["url"], [point], new SpatialReference({wkid:4326})).then(result => {
                if(result[0]){
                    var ipaCoords:any = {
                        x:result[0].x,
                        y:result[0].y
                    }
                    this._eventsService.ipaSetLocation(ipaCoords);
                }
                this.mapPointerUpSubscription.unsubscribe()
            });
        });
    }

    private obliqueImageryDeactivate(){
        this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        this.obliqueToolListActive = false;
        this.mapPointerDownSubscription.unsubscribe();
        if(this.mapDragSubscription){
            this.mapDragSubscription.unsubscribe();
        }
        this.mapPointerUpSubscription ? this.mapPointerUpSubscription.unsubscribe() : null;
        this._mapService.obliquePointGraphicLayer.graphics.removeAll();
        this._eventsService.showObliqueImage(false);
    }

    selectAddressSearchTool(event:any){
        this._eventsService.addressSearchActivate(event.currentTarget.checked);
    }

    selectFilterTool(event:any){

    }

    showSnackBar(dataSnack:any){
        var snackbarContainer = document.querySelector('#demo-toast-example');
        setTimeout(() =>
        {
            snackbarContainer['MaterialSnackbar'].showSnackbar(dataSnack);
        }, 600);
    }

    hideSnackBar(){
        var snackbarContainer = document.querySelector('#demo-toast-example');
        snackbarContainer['MaterialSnackbar'].cleanup_();
    }

    freeHandToolDeactivate(){
        this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        this.freeHandToolListActive = false;
        if(this.drawHandler){
            this.drawHandler.remove();
        }
        // Enable movement of the map again
        // setTimeout(() =>
        // {
            if (this._mapService.view.type === "3d") {
                this._mapService.view['navigationControls'].mouseDragLeft = 'pan';
            } else {
                //this._mapService.view['gestureManager'].inputManager.manager.options.enable = true;
                var handlers:Array<any> = this._mapService.view["inputManager"]._handlers;
                for (var i = 0; i < handlers.length; i++){
                    handlers[i].active = true;
                }
            }
        //}, 2000);
    }

    freeHandToolActivate(){
        this._eventsService.showMapTooltip({"show":true, "tooltip":"Press down to start and let go to finish"});
        this.freeHandToolListActive = true;
        if(this.showFreeHandInstructions == true){
            var dataSnack = {
                message: this.freeHandInstructions, 
                timeout:15000,
                actionHandler: e => {
                    this.hideSnackBar();
                    this.showFreeHandInstructions = false;
                },
                actionText: "Hide"
            };
            this.showSnackBar(dataSnack);
        }
        

        var rings:Array<any> = new Array();
        var currentGraphic;
        var lineSymbol:SimpleLineSymbol = new SimpleLineSymbol();
        lineSymbol.color = new Color([255, 0, 0]);
        lineSymbol.width = 1;
        var fillSymbol:SimpleFillSymbol = new SimpleFillSymbol();
        fillSymbol.color = new Color([0, 0, 0, 0.5]);
        fillSymbol.outline = lineSymbol;
        var geometryEngine:GeometryEngine;
        var currentClickPoint:Point;
        var curScreenPoint:ScreenPoint;
        var screenPointForOffset:ScreenPoint = null;
        var xOffset:Number = 0;
        var yOffset:Number = -104;

        // We temporarily disable the ability to move the map
        if (this._mapService.view.type === "3d") {
            this._mapService.view['navigationControls'].mouseDragLeft = 'select';
            //handler.pause();
        } else {
            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = false;
            var handlers:Array<any> = this._mapService.view["inputManager"]._handlers;
            for (var i = 0; i < handlers.length; i++){
                handlers[i].active = false;
            }
        }

        // this.freeHandDrawMapViewHandler = on(this._mapService.view, "click", evt => {
        //     currentClickPoint = evt.mapPoint;
        //     curScreenPoint = this._mapService.view.toScreen(currentClickPoint);
        // });

        this.drawHandler = on(this._mapService.view.container, "mousedown", evt => {
            // if(screenPointForOffset == null){
            //     screenPointForOffset = new ScreenPoint();
            //     screenPointForOffset.x = evt.x;
            //     screenPointForOffset.y = evt.y;
            //     xOffset = curScreenPoint.x - screenPointForOffset.x;
            //     yOffset = curScreenPoint.y - screenPointForOffset.y;
            // }

            this._eventsService.showMapTooltip({"show":false, "tooltip":""});
            
            rings = [];

            evt.preventDefault();
            

            //Get screen point from evt
            var screenPoint:ScreenPoint = new ScreenPoint();
            screenPoint.x = evt.x + xOffset;
            screenPoint.y = evt.y + yOffset;

            // Get the start point for the temporary line
            var drawStart = new Point();
            this._mapService.view.toMap(screenPoint, drawStart);
            rings.push([drawStart.x, drawStart.y]);

            // The next segment of the line is created by listening to the mousemove
            // event on the view. For each event, we add to the resulting line.
            var nextSegment = on(this._mapService.view.container, "mousemove", mmevt => {
                //mmevt.preventDefault();
                
                // Remove the previous graphic, as we will update it
                // with the new graphic
                if (currentGraphic) {
                    this._mapService.selGraphics.remove(currentGraphic);
                }

                var mmScreenPoint:ScreenPoint = new ScreenPoint();
                mmScreenPoint.x = mmevt.x + xOffset;
                mmScreenPoint.y = mmevt.y + yOffset;

                // Progressivly add new points to the line
                var nextPoint = new Point();
                this._mapService.view.toMap(mmScreenPoint, nextPoint);
                
                //this._mapService.selGraphics.graphics.add(new Graphic({"geometry":nextPoint, symbol: new SimpleMarkerSymbol()}));

                if ((nextPoint.z !== undefined && this._mapService.view.type === '3d') || this._mapService.view.type === '2d') {
                    rings.push([nextPoint.x, nextPoint.y]);
                    
                    // Update the graphic in the graphics layer
                    currentGraphic = new Graphic({
                    geometry: new Polyline({
                        paths: rings,
                        spatialReference: this._mapService.view.spatialReference
                    }),
                    symbol: lineSymbol
                    });

                    this._mapService.selGraphics.graphics.add(currentGraphic);
                }
            });

            // The final segment is a mouseup event on the map.view. When this fires
            // we complete the polygon.
            var lastSegment = on(this._mapService.view.container, "mouseup", muevt => {
                //this.drawHandler.remove();
                
                nextSegment.remove();
                lastSegment.remove();

                // Enable movement of the map again
                if (this._mapService.view.type === "3d") {
                    this._mapService.view['navigationControls'].mouseDragLeft = 'pan';
                } else {
                    //this._mapService.view['gestureManager'].inputManager.manager.options.enable = false;
                    var handlers:Array<any> = this._mapService.view["inputManager"]._handlers;
                    for (var i = 0; i < handlers.length; i++){
                        handlers[i].active = false;
                    }
                }

                // Remove the previous line graphic
                this._mapService.selGraphics.remove(currentGraphic);

                var muScreenPoint:ScreenPoint = new ScreenPoint();
                muScreenPoint.x = muevt.x + xOffset;
                muScreenPoint.y = muevt.y + yOffset;

                // Construct the final point of the line
                var lastPoint = new Point();
                this._mapService.view.toMap(muScreenPoint, lastPoint);

                // Add the original point to the end of the line to
                // complete the polygon
                var firstPointCopy = [rings[0][0], rings[0][1]];
                rings.push(firstPointCopy);

                // Create the polygon and simplify
                var polygon = new Polygon({
                    rings: rings,
                    spatialReference: this._mapService.view.spatialReference
                });

                //var simplePolygon = geometryEngine.simplify(polygon);

                var currentGraphic = new Graphic({
                    geometry: polygon,
                    symbol: fillSymbol
                });

                // Add the graphic
                this._mapService.selGraphics.add(currentGraphic);


                var suggestion:Object = {
                    FullAddress:"Custom Polygon",
                    FullName:"Custom Polygon",
                    Geometry:polygon,
                    SuggestionType: "FreeHandPolygon"
                }
                //Emit event to set selected geometry
                var pickedGeometry:Object = {addressSuggestion: suggestion, addressLocation: suggestion["Geometry"]};
                this._eventsService.changeNav(pickedGeometry);
                this._mapService.view.extent = polygon.extent;



                this._mapService.tempSelPlgGraphics.graphics.removeAll();
                this._mapService.selGraphics.graphics.removeAll();
                this._mapService.tempSelGraphics.graphics.removeAll();

                var mapNavToolEls:NodeListOf<any> = document.getElementsByName("mapToolActive");
                for(var k = 0; k < mapNavToolEls.length; k++){
                    if(mapNavToolEls[k].checked == true && mapNavToolEls[k].id == "free-hand-draw-icon"){
                        mapNavToolEls[k].click();
                    }
                }

                //this._eventsService.multipleSelectComplete(polygon);
            })
        });
    }


    //Draw polygon tool
    drawPolygonToolDeactivate(){
        this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        this.drawPolygonToolListActive = false;
        if(this.drawPolygonHandler){
            this.drawPolygonHandler.remove();
        }
        if(this.polygonDrawMoveHandler){
            this.polygonDrawMoveHandler.remove();
        }
        if(this.polygonDrawDoubleClickHandler){
            this.polygonDrawDoubleClickHandler.remove();
        }
        if(this.drawPolygonScreenClickHandler){
            this.drawPolygonScreenClickHandler.remove();
        }
        this._mapService.tempSelPlgGraphics.graphics.removeAll();
        this._mapService.selGraphics.graphics.removeAll();
        this._mapService.tempSelGraphics.graphics.removeAll();
        // Enable movement of the map again
        if (this._mapService.view.type === "3d") {
            this._mapService.view['navigationControls'].mouseDragLeft = 'pan';
        } else {
            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = true;
                var handlers:Array<any> = this._mapService.view["inputManager"]._handlers;
                for (var i = 0; i < handlers.length; i++){
                    handlers[i].active = true;
                }
        }
    }

    drawPolygonToolActivate(){
        this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to start drawing"});
        this.drawPolygonToolListActive = true;
        if(this.showDrawPolygonInstructions == true){
            var dataSnack = {
                message: this.drawPolygonInstructions, 
                timeout:15000,
                actionHandler: e => {
                    this.hideSnackBar();
                    this.showDrawPolygonInstructions = false;
                },
                actionText: "Hide"
            };
            this.showSnackBar(dataSnack);
        }


        var rings:Array<any> = new Array();
        var tempPolygonRings:Array<any> = new Array();
        var currentGraphic;
        var lineSymbol:SimpleLineSymbol = new SimpleLineSymbol();
        lineSymbol.color = new Color([255, 0, 0]);
        lineSymbol.width = 1;
        var fillSymbol:SimpleFillSymbol = new SimpleFillSymbol();
        fillSymbol.color = new Color([0, 0, 0, 0.5]);
        fillSymbol.outline = null;
        var geometryEngine:GeometryEngine;
        var drawStart:Point;
        var currentClickPoint:Point;
        var screenPointForOffset:ScreenPoint = new ScreenPoint();
        var xOffset:Number;
        var yOffset:Number;

        this.drawPolygonScreenClickHandler = on(this._mapService.view.container, "click", evt => {
            this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to continue drawing"});
            // Get the start point for the temporary line
            if(drawStart){
                //Get screen point from evt
                var screenPoint:ScreenPoint = new ScreenPoint();
                screenPoint.x = evt.x + xOffset;
                screenPoint.y = evt.y + yOffset;

                var drawPoint:Point = this._mapService.view.toMap(screenPoint);
                rings.push([drawPoint.x, drawPoint.y]);
                // Update the graphic in the graphics layer
                currentGraphic = new Graphic({
                  geometry: new Polyline({
                    paths: rings,
                    spatialReference: this._mapService.view.spatialReference
                  }),
                  symbol: lineSymbol
                });
                this._mapService.selGraphics.graphics.add(currentGraphic);
            }else{
                screenPointForOffset.x = evt.x;
                screenPointForOffset.y = evt.y;
                return;
            }

            if(rings.length > 1){
                this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to continue drawing. Double-click to complete."});
                this._mapService.tempSelPlgGraphics.graphics.removeAll();
                tempPolygonRings = [];
                for(var ring of rings){
                    tempPolygonRings.push(ring);
                }
                var firstPointCopy = [rings[0][0], rings[0][1]];
                tempPolygonRings.push(firstPointCopy);
                // Update the graphic in the graphics layer
                currentGraphic = new Graphic({
                  geometry: new Polygon({
                    rings: tempPolygonRings,
                    spatialReference: this._mapService.view.spatialReference
                  }),
                  symbol: fillSymbol
                });
                this._mapService.tempSelPlgGraphics.graphics.add(currentGraphic);
            }
        });

        this.drawPolygonHandler = on(this._mapService.view, "click", evt => {
            if(drawStart){
                return;
            }
            currentClickPoint = evt.mapPoint;
            var curScreenPoint:ScreenPoint = this._mapService.view.toScreen(currentClickPoint);

            drawStart = currentClickPoint;
            rings.push([drawStart.x, drawStart.y]);
            xOffset = curScreenPoint.x - screenPointForOffset.x;
            yOffset = curScreenPoint.y - screenPointForOffset.y;

            // We temporarily disable the ability to move the map
            if (this._mapService.view.type === "3d") {
                this._mapService.view['navigationControls'].mouseDragLeft = 'select';
            } else {
                //this._mapService.view['gestureManager'].inputManager.manager.options.enable = false;
                var handlers:Array<any> = this._mapService.view["inputManager"]._handlers;
                for (var i = 0; i < handlers.length; i++){
                    handlers[i].active = false;
                }
            }
        });

        this.polygonDrawMoveHandler = on(this._mapService.view.container, "mousemove", evt => {
            if(drawStart){
                this._mapService.tempSelGraphics.graphics.removeAll();

                var paths:Array<any> = [];
                paths[0] = rings[rings.length - 1];
                
                //Get screen point from evt
                var screenPoint:ScreenPoint = new ScreenPoint();
                screenPoint.x = evt.x + xOffset;
                screenPoint.y = evt.y + yOffset;

                var nextPoint = new Point();
                this._mapService.view.toMap(screenPoint, nextPoint);

                paths[1] = [nextPoint.x, nextPoint.y];

                // Update the graphic in the graphics layer
                currentGraphic = new Graphic({
                  geometry: new Polyline({
                    paths: paths,
                    spatialReference: this._mapService.view.spatialReference
                  }),
                  symbol: lineSymbol
                });

                this._mapService.tempSelGraphics.graphics.add(currentGraphic);
            }
        });

        this.polygonDrawDoubleClickHandler = on(this._mapService.view.container, "dblclick", evt => {
            if(rings.length < 3){
                this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to start drawing"});
                return;
            }
            if(rings.length < 4){
                this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to continue drawing"});
                return;
            }
            //this._eventsService.multipleSelectComplete(new Polygon({rings:tempPolygonRings, spatialReference: this._mapService.view.spatialReference}));
            rings = new Array();
            tempPolygonRings = new Array();
            drawStart = null;

            var suggestion:Object = {
                FullAddress:"Custom Polygon",
                FullName:"Custom Polygon",
                Geometry: (this._mapService.tempSelPlgGraphics.graphics.getItemAt(0) as Graphic).geometry,
                SuggestionType: "DrawPolygon"
            }
            //Emit event to set selected geometry
            var pickedGeometry:Object = {addressSuggestion: suggestion, addressLocation: suggestion["Geometry"]};
            this._eventsService.changeNav(pickedGeometry);

            this._mapService.view.extent = (this._mapService.tempSelPlgGraphics.graphics.getItemAt(0) as Graphic).geometry.extent;

            this._mapService.tempSelPlgGraphics.graphics.removeAll();
            this._mapService.selGraphics.graphics.removeAll();
            this._mapService.tempSelGraphics.graphics.removeAll();

            // Enable default events
            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = true;
            var handlers:Array<any> = this._mapService.view["inputManager"]._handlers;
            for (var i = 0; i < handlers.length; i++){
                handlers[i].active = true;
            }

            this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to start drawing"});
        });
    }



    NEWFreeHandPolygonToolActivate(){
        this._eventsService.showMapTooltip({"show":true, "tooltip":"Press down to start and let go to finish"});
        this.freeHandToolListActive = true;
        if(this.showFreeHandInstructions == true){
            var dataSnack = {
                message: this.freeHandInstructions, 
                timeout:15000,
                actionHandler: e => {
                    this.hideSnackBar();
                    this.showFreeHandInstructions = false;
                },
                actionText: "Hide"
            };
            this.showSnackBar(dataSnack);
        }

        var paths:Array<any> = [];
        var currentGraphic;
        
        var lineSymbol:SimpleLineSymbol = new SimpleLineSymbol();
        lineSymbol.color = new Color([255, 0, 0]);
        lineSymbol.width = 1;

        this.mapPointerDownSubscription = this._eventsService.mapPointerDown$.subscribe(mdevt => {

            this._mapService.selGraphics.removeAll();

            mdevt.stopPropagation();
            var point:Point = this._mapService.view.toMap(new ScreenPoint({
                x:mdevt.x,
                y:mdevt.y
            }));
            paths.push([point.x, point.y]);
            
            this.mapDragSubscription = this._eventsService.mapDrag$.subscribe(devt => {
                this._mapService.selGraphics.removeAll();
                devt.stopPropagation();
                var dragPoint:Point = this._mapService.view.toMap(new ScreenPoint({
                    x:devt.x,
                    y:devt.y
                }));
                paths.push([dragPoint.x, dragPoint.y]);
                currentGraphic = new Graphic({
                    geometry: new Polyline({
                        paths: paths,
                        spatialReference: this._mapService.view.spatialReference
                    }),
                    symbol: lineSymbol
                });
                this._mapService.selGraphics.graphics.add(currentGraphic);
            });

            this.mapPointerUpSubscription = this._eventsService.mapPointerUp$.subscribe(muevt => {
                var endPoint:Point = this._mapService.view.toMap(new ScreenPoint({
                    x:muevt.x,
                    y:muevt.y
                }));
                paths.push([endPoint.x, endPoint.y]);
                paths.push([point.x, point.y]);

                var polygon:Polygon = new Polygon({
                    rings: paths,
                    spatialReference: this._mapService.view.spatialReference
                });

                var suggestion:Object = {
                    FullAddress:"Custom Polygon",
                    FullName:"Custom Polygon",
                    Geometry:polygon,
                    SuggestionType: "FreeHandPolygon"
                }
                //Emit event to set selected geometry
                var pickedGeometry:Object = {addressSuggestion: suggestion, addressLocation: suggestion["Geometry"]};
                this._eventsService.changeNav(pickedGeometry);
                this._mapService.view.extent = polygon.extent;

                this._mapService.selGraphics.graphics.removeAll();

                this.mapDragSubscription.unsubscribe();
                this.mapPointerUpSubscription.unsubscribe();
                this.mapPointerDownSubscription.unsubscribe();

                var mapNavToolEls:NodeListOf<any> = document.getElementsByName("mapToolActive");
                for(var k = 0; k < mapNavToolEls.length; k++){
                    if(mapNavToolEls[k].checked == true && mapNavToolEls[k].id == "free-hand-draw-icon"){
                        mapNavToolEls[k].click();
                    }
                }
            });
        });
    }

    NEWFreeHandPolygonToolDeactivate(){
        this.mapPointerDownSubscription.unsubscribe();
        if(this.mapDragSubscription){
            this.mapDragSubscription.unsubscribe();
        }
        this.mapPointerUpSubscription ? this.mapPointerUpSubscription.unsubscribe() : null;
        this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        this.freeHandToolListActive = false;
    }

    NEWdrawPolygonToolActivate(){
        this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to start drawing"});
        this.drawPolygonToolListActive = true;
        if(this.showDrawPolygonInstructions == true){
            var dataSnack = {
                message: this.drawPolygonInstructions, 
                timeout:15000,
                actionHandler: e => {
                    this.hideSnackBar();
                    this.showDrawPolygonInstructions = false;
                },
                actionText: "Hide"
            };
            this.showSnackBar(dataSnack);
        }

        var rings:Array<any> = [];
        var currentGraphic;

        var lineSymbol:SimpleLineSymbol = new SimpleLineSymbol();
        lineSymbol.color = new Color([255, 0, 0]);
        lineSymbol.width = 1;

        this.mapPointerUpSubscription = this._eventsService.mapPointerUp$.subscribe(muevt => {
            //this._mapService.selGraphics.removeAll();
            muevt.stopPropagation();
            this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to continue drawing"});

            var point:Point = this._mapService.view.toMap(new ScreenPoint({
                x:muevt.x,
                y:muevt.y
            }));
            
            rings.push([point.x, point.y]);
            this._mapService.selGraphics.add(new Graphic({
                geometry: new Polyline({
                    paths: rings,
                    spatialReference: this._mapService.view.spatialReference
                }),
                symbol: lineSymbol
            }));
            
            if(rings.length < 2){
                this.mapPointerMoveSubscription = this._eventsService.mapPointerMove$.subscribe(mmevt => {
                    mmevt.stopPropagation();
                    this._mapService.tempSelGraphics.removeAll();
                    var mmPoint:Point = this._mapService.view.toMap(new ScreenPoint({
                        x:mmevt.x,
                        y:mmevt.y
                    }));
                    var paths:Array<any> = [];
                    paths[0] = rings[rings.length - 1];
                    paths[1] = [mmPoint.x, mmPoint.y];
                    currentGraphic = new Graphic({
                        geometry: new Polyline({
                            paths: paths,
                            spatialReference: this._mapService.view.spatialReference
                        }),
                        symbol: lineSymbol
                    });
                    this._mapService.tempSelGraphics.add(currentGraphic);
                });

                this.mapDoubleClickSubscription = this._eventsService.mapDoubleClick$.subscribe(mdcevt => {
                    mdcevt.stopPropagation();
                    if(rings.length >= 2){
                        this.mapPointerUpSubscription.unsubscribe();
                        this.mapPointerMoveSubscription.unsubscribe();
                        this.mapDoubleClickSubscription.unsubscribe();

                        rings.push([mdcevt.mapPoint.x, mdcevt.mapPoint.y]);
                        rings.push(rings[0]);
                        // Create the polygon and simplify
                        var polygon:Polygon = new Polygon({
                            rings: rings,
                            spatialReference: this._mapService.view.spatialReference
                        });
                        var suggestion:Object = {
                            FullAddress:"Custom Polygon",
                            FullName:"Custom Polygon",
                            Geometry:polygon,
                            SuggestionType: "DrawPolygon"
                        }
                        //Emit event to set selected geometry
                        var pickedGeometry:Object = {addressSuggestion: suggestion, addressLocation: suggestion["Geometry"]};
                        this._eventsService.changeNav(pickedGeometry);
                        this._mapService.view.extent = polygon.extent;

                        this._mapService.selGraphics.graphics.removeAll();
                        this._mapService.tempSelGraphics.graphics.removeAll();

                        var mapNavToolEls:NodeListOf<any> = document.getElementsByName("mapToolActive");
                        for(var k = 0; k < mapNavToolEls.length; k++){
                            if(mapNavToolEls[k].checked == true && mapNavToolEls[k].id == "polygon-draw-icon"){
                                mapNavToolEls[k].click();
                            }
                        }

                        // var unsubscribeEventsInterval = setInterval(() => {
                        //     if(this.mapPointerUpSubscription.closed == true && this.mapPointerMoveSubscription.closed == true && this.mapDoubleClickSubscription.closed == true){
                        //         this.NEWdrawPolygonToolActivate();
                        //         clearInterval(unsubscribeEventsInterval);
                        //     }
                        // }, 200);
                    }
                });
            }else{
                this._eventsService.showMapTooltip({"show":true, "tooltip":"Click to continue drawing. Double-click to complete."});
            }
        });
    }

    NEWdrawPolygonToolDeactivate(){
        this.mapPointerMoveSubscription ? this.mapPointerMoveSubscription.unsubscribe() : null;
        if(this.mapDoubleClickSubscription){
            this.mapDoubleClickSubscription.unsubscribe();
        }
        this.mapPointerUpSubscription ? this.mapPointerUpSubscription.unsubscribe() : null;
        this._eventsService.showMapTooltip({"show":false, "tooltip":""});
        this.drawPolygonToolListActive = false;
    }
}


// WEBPACK FOOTER //
// ./app/tools/navTools.component.ts